var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{on:{"click":function($event){return _vm.gotoProcesso(_vm.processo)}}},[_c('strong',[_vm._v(_vm._s(_vm.processo.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }